































import ApiClient from '@/js/api.js'
import FirstView from '@/views/templates/africadogs/FirstView.vue'
import UserPager from '@/views/templates/tenugui/UserPager.vue'
import Episode0 from '@/views/templates/africadogs/Episode0.vue'
import Episode1 from '@/views/templates/africadogs/Episode1.vue'
import Episode2_1 from '@/views/templates/africadogs/Episode2_1.vue'
import Episode2_2 from '@/views/templates/africadogs/Episode2_2.vue'
import Episode2_3 from '@/views/templates/africadogs/Episode2_3.vue'
import Episode3 from '@/views/templates/africadogs/Episode3.vue'
import Episode4_1 from '@/views/templates/africadogs/Episode4_1.vue'
import Episode4_2 from '@/views/templates/africadogs/Episode4_2.vue'
import Episode4_3 from '@/views/templates/africadogs/Episode4_3.vue'
import Episode4_4 from '@/views/templates/africadogs/Episode4_4.vue'
import Episode5 from '@/views/templates/africadogs/Episode5.vue'
import Episode6 from '@/views/templates/africadogs/Episode6.vue'
import Episode7 from '@/views/templates/africadogs/Episode7.vue'
import Footer from '@/views/templates/Footer.vue'
import ShopListButton from '@/views/atoms/ShopListButton.vue'
import PopupFirst from '@/views/templates/africadogs/PopupFirst.vue'
import PopupInitial from '@/views/templates/PopupInitial.vue'

export default
  components: {
    FirstView
    UserPager
    Episode0
    Episode1
    Episode2_1
    Episode2_2
    Episode2_3
    Episode3
    Episode4_1
    Episode4_2
    Episode4_3
    Episode4_4
    Episode5
    Episode6
    Episode7

    Footer
    ShopListButton
    PopupFirst
    PopupInitial
  }

  created: () ->
    api = new ApiClient()
    data = await api.get('/member/point/owned')
    @myPoint = data.point

  data: () ->
    position: 0
    myPoint: 0
    showShopListButton: false
    isFirstAccess: window.isFirstAccess
    showPopup: [
      0
      0
    ]

  methods: {
    go_top: () ->
      @lock_episode2()
    first_entry: (e) ->
      if @showPopup[0] == 0
        @$set(@showPopup, 0, 1)

    scroll_fire: (pos) ->
      @position = pos
      if pos == 5
        @$cookies.set('showed_afurikadogs', 1, 9999999999)
        @showShopListButton = true
    first_entry: (e) ->
      if @showPopup[0] == 0
        @$set(@showPopup, 0, 1)
    close_first_popup: (e) ->
      @$set(@showPopup, 0, 2)
    add_point: (point) ->
      @myPoint += point
    second_entry: (e) ->
      if @showPopup[1] == 0
        @$set(@showPopup, 1, 1)
    close_second_popup: (e) ->
      @$set(@showPopup, 1, 0)
    third_entry: (e) ->
      if @showPopup[2] == 0
        @$set(@showPopup, 2, 1)
    close_third_popup: (e) ->
      @$set(@showPopup, 2, 0)
    four_entry: (e) ->
      if @showPopup[3] == 0
        @$set(@showPopup, 3, 1)
    close_four_popup: (e) ->
      @$set(@showPopup, 3, 0)
    lock_episode2: () ->
      document.querySelector('.episode2').style.top = 0
    unlock_episode2: () ->
      document.querySelector('.episode2').style.top = 'auto'
    show_itemlist: (e) ->
      @$router.push '/item/list/afurikadogs'
    go_close: (e) ->
      @isFirstAccess = false
  }

